import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Label from "../../../components/commonComponents/Label";
import Button from "../../../components/common/Button";
import Checkbox from "../../../components/common/Checkbox";
import Form from "../../../components/common/Form";
import Input from "../../../components/common/Input";
import Logo from "../../../components/logo/Logo";
import { Modal } from "react-bootstrap";
import SocialLogin from "../../../components/socialLogin/SocialLogin";
import { SERVER_URL } from "../../../config";
import { phoneField, titleOptions, titleOptionsNew } from "../../../constants";
import { registerNewVendor } from '../../../store/apiCalls/authentication';
import { SET_LOGIN_USER_SUCCESS, SET_TOKEN_ON_REGISTRATION } from "../../../store/actions/loginActions";
import {
  handleShowPassword,
  validateEmail,
  validatePhoneNumber,
} from "../../../utils";
import { OnSocialLogin } from "../login/queries";
import "./index.scss";
import { OnRegisterVendor } from "./queries";
import Divider from "../../../components/common/Divider";

import active_promo from "../../../svg/active_promo.svg";
import disable_promo from "../../../svg/disable_promo.svg";
import active_eye from "../../../svg/active-eye.svg";
import active_email from "../../../svg/active-email.svg";
import active_lock from "../../../svg/active-lock.svg";
import disable_eye from "../../../svg/disable-eye.svg";
import disable_email from "../../../svg/disable-email.svg";
import disable_lock from "../../../svg/disable-lock.svg";
import disable_phone from "../../../svg/disable-phone.svg";
import active_phone from "../../../svg/active-phone.svg";
import disable_organization from "../../../svg/disable-organization.svg";
import active_organization from "../../../svg/active-organization.svg";
import FormModal from "../../../components/Modal/formModal";
import SuccessModal from "../../../components/Modal/successModal";
import { OnResendOtp, VerifyVendorEmail } from "../verifyEmail/queries";
import VerifyOtp from "../verifyotp";
import LeftBase from "../../../components/common/LeftBase";
import verifiedIcon from "../../../svg/verifiedCheck.svg";
import active_info from "../../../svg/active-info.svg";
import Select from "../../../components/commonComponents/Select";
import TermModal from "../../../components/commonComponents/termModal";
import PrivacyModal from "../../../components/commonComponents/PrivacyModal";

function Registration() {
  const [show, setShow] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const handleAcceptTermsClose = () => {
    setChecked(!checked);
    setShow(false);
  }
  const handleTermsClose = () => {
    setShow(false);
  }

  const handleAcceptPrivacyClose = () => {
    setChecked(!checked);
    setShowPrivacy(false);
  }
  const handlePrivacyClose = () => {
    setShowPrivacy(false);
  }

  const [registrationData, setRegistrationData] = useState({referralCode: new URLSearchParams(window.location.search).get("promo")});
  const [VerifyPopupOpen, setVerifyPopupOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('')
  const [otp, setOtp] = useState();
  const [registrationModal, setRegistrationModal] = useState({show: false, published: false});
  const [mobileOtp, setMobileotp] = useState()
  const [userId, setUserId] = useState()
  const [VerifyMobilePopupOpen, setVerifyMobilePopupOpen] = useState(false);
  const [error, setError] = useState({ apiError: '' })
  const [getInformation,setGetInformation]=useState(false)
  const [showPassword, setShowPassword] = useState({
    setPassword: false,
    confirmPassword: false,
  });
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [openConfermationModal, setOpenConfermationModal] = useState(false)
  const [token, setToken] = useState('')
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sucessHandler = (sucess = {}) => {
    setUserId(sucess?.data?.userId)
    // setMobileotp(sucess?.data?.otpForMobileVerification)
    setVerifyPopupOpen(false)
    setToken(sucess?.data?.token)
    setVerifyMobilePopupOpen(true);
  };
  
  const EmailsucessHandler = (sucess) => {
    setErrorMsg('')
    setVerifyPopupOpen(false)
    setOpenConfermationModal(true)
  }
  const MobilesucessHandler = (sucess) => {
    setMobileotp()
    setErrorMsg('')
    setOtp()
    setVerifyMobilePopupOpen(false)
    setVerifyPopupOpen(true)
  }

  const handleVerifyEmailSubmit = (e) => {
    e.preventDefault()
    const headers = {
      otp: otp,
      userId: userId
    }
    verifyEmail(headers)
  }

  const handleVerifyMobileSubmit = (e) => {
    e.preventDefault()
    const headers = {
      otpForMobileVerification: mobileOtp,
      userId: userId
    }
    verifyMobile(headers)
  }
  const resendOtpSucess = (sucess) => {
    if (sucess?.data?.otpformobileverification) {
    //   setMobileotp(sucess?.data?.otpformobileverification)
      setMobileotp("");
    }
  }

  const handleRedirect = (e) => {
    e.preventDefault();
    if(registrationModal.published) {
      window.location.href = SERVER_URL
    } else {
      navigate('/')
    }
  }

  const handleRedirectVideo = (e) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    window.navigation.navigate(SERVER_URL + "browse");
  }

  const handleRensedOtp = (e, type) => {
    e.preventDefault()
    if (type === 'email') {
      let param = {
        email: registrationData?.email
      }
      resedOtp(param)
    }
    else {

      let param = {
        phoneNumber: registrationData?.phoneNumber
      }
      resedOtp(param)
    }
  }
  const { mutate: resedOtp } = OnResendOtp(resendOtpSucess, setErrorMsg)
  const { mutate: verifyEmail } = VerifyVendorEmail(EmailsucessHandler, setErrorMsg);
  const { mutate: verifyMobile } = VerifyVendorEmail(MobilesucessHandler, setErrorMsg);
  const { mutate: registerVendor } = OnRegisterVendor(sucessHandler, error, setError);

  const socialSucessHandler = (success) => {
    if(!success?.data?.isSetupProfile) {
      localStorage.setItem("vendorToken", success.data?.token);
      dispatch({
        type: SET_LOGIN_USER_SUCCESS,
        payload: success?.data,
      });
  
      navigate("/");
      return null;
    } else {
      setRegistrationModal({show: true, published: success?.data?.isSetupProfile ? true : false});
    }
  };

  const { mutate: socialLogin } = OnSocialLogin(socialSucessHandler, error, setError);

  const handleSocialLogin = (result) => {
    const data = result?.user;
    const apiBody = {
      fullName: data?.displayName,
      email: (result?.providerId === "twitter.com") ? result?.['_tokenResponse']?.email : data?.email,
      rawId: data?.uid,
      isSocialLogin: true,
    };
    socialLogin(apiBody);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredParam = {};
    requiredParam.fullName = registrationData?.fullName;
    requiredParam.title=registrationData?.title
    requiredParam.email = registrationData?.email;
    if(registrationData.referralCode) {
      requiredParam.referralCode = registrationData?.referralCode;    
    }
    requiredParam.phoneNumber = registrationData?.phoneNumber;
    requiredParam.password = registrationData?.setPassword;
    requiredParam.organizationName = registrationData?.organizationName || "";
    if (registrationData.setPassword !== registrationData.confirmPassword) {
      return setError({ ...error, apiError: "SetPassword and ConfirmPassword are not same" })
    }
    
    dispatch({type: "SET_LOADER_STATUS", loading: true})
    const regResp = await registerNewVendor(requiredParam);
    dispatch({type: "SET_LOADER_STATUS", loading: false})
    if(regResp?.data?.success) {
      sucessHandler(regResp)
      setError({apiError: ""})
    } else if((regResp?.response?.status === 400)) {
      let error = { message: regResp?.response?.data?.message }
      if (regResp?.response?.status === 412) {
          error = { message: regResp.response.data.message + " " + regResp?.response?.data?.data?.errors?.password[0] }
      }
      if(regResp?.response?.data?.emailAreadyRegistered) {
        setRegistrationModal({show: true, published: regResp?.response?.data?.isSetupProfile ? true : false});
      }
      setError({apiError: error?.message})
    } else {
      setError({apiError: regResp?.response?.data?.message})
    }
  };


  const handleSelectChange = (data, type) => {
    setErrorMsg("");
    return setRegistrationData({ ...registrationData, [type]: data });
  }

  const handleChange = (e) => {
    const { value, name } = e.target;
    if (name === phoneField) {
      return setRegistrationData({
        ...registrationData,
        [name]: validatePhoneNumber(value),
      });
    }
    setErrorMsg("");
    return setRegistrationData({ ...registrationData, [name]: value });
  };

  useEffect(() => {
    setDisabled(
      !(
        registrationData?.fullName &&
        validateEmail(registrationData?.email) &&
        registrationData?.phoneNumber?.length === 10 &&
        registrationData?.setPassword &&
        registrationData?.confirmPassword &&
        registrationData?.title &&
        checked
      )
    );
  }, [registrationData, checked]);
  const handleConfermationModalSubmit = () => {
    setOpenConfermationModal(false)
    localStorage.setItem('vendorToken', token)
    dispatch({
      type: SET_TOKEN_ON_REGISTRATION,
      payload: { token: token, _id: userId },
    });
    navigate('/')
  }

  return (
    <div className="container-flex register-page">
      <div className="row h-100">
        <div className="col-lg-4 col-xl-4 d-none d-lg-block left-base position-relative left-base">
          <LeftBase  />
        </div>
        <div className="col-lg-8 col-xl-8 col-md-12 col-sm-12 m-auto">
          <p className="welcome_title py-2 text-end top_link">
            Already a member?<Link to="/" className="link"> Login Now </Link>
          </p>
          <div className="frame w-75 m-auto">
            <Logo />
            <h4 className="mt-40 p-0 mb-1">BECOME A SELLER</h4>
            <p className="sub_title">
              Showcase your skills. Join our growing freelance community.
            </p>
            <Form onSubmit={handleSubmit}>
              <div className="title_with_name">
                <div className="w-25 me-1 title-container">
                <Label className={registrationData.title ? "labelForm" : "hidden"} labelText="Title" />
                  <Select
                    handleChange={handleSelectChange}
                    selectedValue={registrationData.title}
                    labelClass={registrationData?.title ? "" : "hidden"}
                    options={titleOptionsNew?.map(val => val?.key)}
                    optionValues={titleOptionsNew?.map(val => val?.value)}
                    label="Title"
                    placeholder="Title"
                    name="title"
                  />
                </div>
                <div className="w-100">
                  <Input
                    name="fullName"
                    className={
                      registrationData?.fullName
                        ? "form-control active-input"
                        : "form-control grey-input"
                    }
                    handleChange={handleChange}
                    type="text"
                    labelClass={registrationData?.fullName ? "" : "hidden"}
                    label="Full Name"
                    placeholder="Full Name"
                    value={registrationData.fullName}
                  />
                </div>
              </div>

              <div className="position-relative">
                <Input
                  type="text"
                  name="organizationName"
                  preIconClass={
                    registrationData?.organizationName ? active_organization : disable_organization
                  }
                  handleChange={handleChange}
                  value={registrationData?.organizationName}
                  placeholder="Company Name"
                  className={
                    registrationData?.organizationName
                      ? "form-control with_icon active-input"
                      : "form-control with_icon grey-input"
                  }
                  labelClass={registrationData?.organizationName ? "" : "hidden"}
                  label="Company Name"
                  optionLabel={true}
                />
                {!registrationData?.organizationName &&
                  <span className="optional-badge">Optional</span>

                }
              </div>
              <div className="position-relative">
                <span className={registrationData?.phoneNumber ? "tel-active" : "tel-disable"}>+91 <span className="ms-6">|</span></span>
                <Input
                  type="tel"
                  name="phoneNumber"
                  preIconClass={
                    registrationData?.phoneNumber ? active_phone : disable_phone
                  }
                  handleChange={handleChange}
                  value={registrationData.phoneNumber}
                  placeholder="xxxxxxxxxx"
                  className={
                    registrationData?.phoneNumber
                      ? "form-control with_icon active-input tel-pd"
                      : "form-control with_icon grey-input tel-pd"
                  }
                  labelClass={registrationData?.phoneNumber ? "" : "hidden"}
                  label="Mobile Number"
                />
              </div>
              <Input
                name="email"
                handleChange={handleChange}
                type="email"
                preIconClass={
                  registrationData?.email ? active_email : disable_email
                }
                placeholder="Email ID"
                value={registrationData?.email}
                className={
                  registrationData?.email
                    ? "form-control with_icon active-input"
                    : "form-control with_icon grey-input"
                }
                labelClass={registrationData?.email ? "" : "hidden"}
                label="Email ID"
              />
              <Input
                name="setPassword"
                handleChange={handleChange}
                type={!showPassword?.setPassword ? "password" : "text"}
                preIconClass={
                  registrationData?.setPassword ? active_lock : disable_lock
                }
                postIconClass={
                  registrationData?.setPassword ? active_eye : disable_eye
                }
                value={registrationData?.setPassword}
                placeholder="Set Password"
                pattern="^(?=(?:.*[a-z]){1,})(?=(?:.*[A-Z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*-]){1,}).{8,}$"
                title="Password should be of 8 character with one number, one capital letter and a special character."
                onIconClick={() =>
                  handleShowPassword(
                    setShowPassword,
                    showPassword,
                    "setPassword"
                  )
                }
                className={
                  registrationData?.setPassword
                    ? "form-control with_icon active-input"
                    : "form-control with_icon grey-input"
                }
                labelClass={registrationData?.setPassword ? "pwd" : "hidden"}
                label="Set Password"
                labelIcon={active_info}
              />
              <Input
                name="confirmPassword"
                handleChange={handleChange}
                type={!showPassword?.confirmPassword ? "password" : "text"}
                preIconClass={
                  registrationData?.confirmPassword ? active_lock : disable_lock
                }
                postIconClass={
                  registrationData?.confirmPassword ? active_eye : disable_eye
                }
                value={registrationData?.confirmPassword}
                placeholder="Confirm Password"
                onIconClick={() =>
                  handleShowPassword(
                    setShowPassword,
                    showPassword,
                    "confirmPassword"
                  )
                }
                className={
                  registrationData?.confirmPassword
                    ? "form-control with_icon active-input"
                    : "form-control with_icon grey-input"
                }
                labelClass={registrationData?.confirmPassword ? "" : "hidden"}
                label="Confirm Password"
                pattern="^(?=(?:.*[a-z]){1,})(?=(?:.*[A-Z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*-]){1,}).{8,}$"
                title="Password should be of 8 character with one number, one capital letter and a special character."
              />

              <div className="position-relative refferal">
                <Input
                  type="text"
                  name="referralCode"
                  preIconClass={
                    registrationData?.referralCode ? active_promo : disable_promo
                  }
                  handleChange={handleChange}
                  value={registrationData?.referralCode}
                  placeholder="Referral Code"
                  className={
                    registrationData?.referralCode
                      ? "form-control with_icon active-input"
                      : "form-control with_icon grey-input"
                  }
                  labelClass={registrationData?.referralCode ? "" : "hidden"}
                  label="Referral Code"
                  optionLabel={true}
                />
                {!registrationData?.referralCode &&
                  <span className="optional-badge">Optional</span>

                }
              </div>

              <div className="label-error">{error?.apiError}</div>
              <div className="position-relative terms-text">
              <label className="small pt-2 text-start styledCheck d-flex align-items-center mb-4">
                <Checkbox
                  className="me-1 form-check-input info-check"
                  checked={checked}
                  onClick={() => setChecked(!checked)}
                />
               <span>
                <span className="text-regular"> I have read Seva Haat's</span>
                    <TermModal show={show} handleTermsClose={handleTermsClose} handleAcceptTermsClose={handleAcceptTermsClose} />
                    <Link href="#" onClick={() => setShow(true)} className="mx-1 link">
                      Terms of use
                    </Link>{" "}
                    <span className="text-regular"> and</span>
                    <PrivacyModal showPrivacy={showPrivacy} handlePrivacyClose={handlePrivacyClose} handleAcceptPrivacyClose={handleAcceptPrivacyClose} />
                    <Link href="#" onClick={(e) => setShowPrivacy(true)} className="mx-1 link">
                      Privacy Policy
                    </Link>
                </span>
              </label>
              </div>
              <Button type="submit" title="CONTINUE" disabled={disabled} />
            </Form>
            <div className="my-4">
              <Divider />
            </div>
            <div className="my-2">
              <p className="welcome_title loginwith_txt">You can also login with</p>
            </div>
            <SocialLogin handleSocialLogin={handleSocialLogin} />
            <div className="col-pd mb-20 position-relative">
              <label  className="d-flex align-items-center styledCheck info-condition mb-3"><Checkbox checked={getInformation}
                  onClick={() => setGetInformation(!getInformation)}  className="form-check-input" />
                  <span className="link ms-2">I'd like to get information on new projects and marketing activities</span>
                  
                </label>
            </div>
            <small className="footer_note">
              Do not forget to add us to your <span className="f-600">Safe Senders List</span><br />We will NEVER post anything without your permission. Isn't this cool?
            </small>
          </div>
          <FormModal show={VerifyMobilePopupOpen}
           customClass={"Verify_Mobile_popup"}
            informationText="Please enter the OTP sent to your mobile number" modalHeading='Verify Mobile Number'>
            <VerifyOtp errorMsg={errorMsg} handleRensedOtp={handleRensedOtp} otp={mobileOtp} setOtp={setMobileotp} handleSubmit={handleVerifyMobileSubmit} type='mobile' />
          </FormModal>

          <FormModal show={VerifyPopupOpen} handleClose={() => setVerifyPopupOpen(false)} upperInformationText={`Your mobile number has been successfully verified <img src=${verifiedIcon} alt="email" class="mx-1 pb-1" />`} informationText="Please enter the OTP sent to your Email ID" modalHeading='Verify Email ID'>
            <VerifyOtp errorMsg={errorMsg} handleRensedOtp={handleRensedOtp} otp={otp} setOtp={setOtp} handleSubmit={handleVerifyEmailSubmit} type='email' />
          </FormModal>

          <Modal backdrop="static" show={registrationModal.show} className="success-modal re-register " centered>
            <Modal.Header className="justify-content-center">
                <Modal.Title className="reg-title">YOU ARE ALREADY REGISTERED</Modal.Title>
                <button
                  type="button"
                  className="btn-close"
                  onClick={(e) => setRegistrationModal({show: false, published: false})}
                  aria-label="Close"
                />
            </Modal.Header>
              <div className="text-center f-700 label" dangerouslySetInnerHTML={{ __html: "We will get in touch with you soon..." }}/>
              <div className="text-center label mt-3 color-black f-size-16" dangerouslySetInnerHTML={{ __html: "Till then, we welcome you to listen to" }}/>
            {/* <Modal.Body></Modal.Body> */}
            <Modal.Footer className="justify-content-center">
                <Button handleClick={(e) => handleRedirectVideo(e)} title="MESSAGE FROM THE FOUNDER" type='button' />
                <div className="text-center">
                  <a onClick={handleRedirect} href='/' className="link text-decoration-none f-700">{registrationModal.published ? "Home" : "Continue Building Your Profile"}</a>
              </div>
            </Modal.Footer>
        </Modal>

          <SuccessModal
            modalHeading="CONGRATULATIONS!"
            upperInformationText={`Mobile number verified <img src=${verifiedIcon} alt="email" class="mx-1 pb-1" />Email ID verified <img src=${verifiedIcon} alt="email" class="mx-1 pb-1" /> `}
            lowerInformationText="Please set up your profile to continue"
            show={openConfermationModal}
            handleClose={()=> setOpenConfermationModal(false)}
            closebutton={true}
            onSubmit={handleConfermationModalSubmit}
            submitButtonTitle="BUILD YOUR PROFILE"
          />
        </div>
      </div>
    </div>
  );
}

export default Registration;
